import styled from "styled-components"
import breakpoints from "./breakpoints"

const VideoWrapper = styled.div`
    grid-column: span 4;
    margin-bottom: 1.6rem;
    @media screen and (min-width: ${breakpoints.sm}px) {
      grid-column: 1 / 5;
    }
    @media screen and (min-width: ${breakpoints.md}px) {
      grid-column: 1 / 8;
    }

`

export {
    VideoWrapper
}